// extracted by mini-css-extract-plugin
export default {"content":"AdvertEdit_content__qEjE5"};